<script setup lang="ts">
/**
 * Dizeres de compliance do modal de login/register (ENG-404, item 2).
 *
 * Renderizado dentro do modal de login e register quando authComplianceMode
 * está ligado (default). Só o botão "Entrar/Criar conta" do header abre sem
 * (compliance:false). Wrapper fino do bloco genérico BaseComplianceInfo
 * (+18, advertência oficial rotativa e identificação do operador).
 */
</script>

<template>
  <BaseComplianceInfo />
</template>
